/**
 * 認証機能のZodスキーマ定義
 * UNIFIED_DEVELOPMENT_GUIDE準拠
 */

import { z } from 'zod';

/**
 * ログインフォームのバリデーションスキーマ
 */
export const loginFormSchema = z.object({
  email: z
    .string()
    .min(1, 'メールアドレスは必須です')
    .email('正しいメールアドレスを入力してください'),
  password: z
    .string()
    .min(1, 'パスワードは必須です')
    .min(7, 'パスワードは7文字以上で入力してください'),
  remember: z.boolean().default(false),
});

/**
 * NFCログインのバリデーションスキーマ
 */
export const nfcLoginSchema = z.object({
  nfc_id: z
    .string()
    .min(1, 'NFCカードIDは必須です')
    .regex(/^[A-Fa-f0-9]{8,16}$/, 'NFCカードIDの形式が不正です'),
  store_id: z.number().optional(),
});

/**
 * パスワードリセット要求スキーマ
 */
export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .min(1, 'メールアドレスは必須です')
    .email('正しいメールアドレスを入力してください'),
});

/**
 * パスワードリセットスキーマ
 */
export const resetPasswordSchema = z.object({
  token: z.string().min(1, 'トークンは必須です'),
  email: z
    .string()
    .min(1, 'メールアドレスは必須です')
    .email('正しいメールアドレスを入力してください'),
  password: z
    .string()
    .min(1, 'パスワードは必須です')
    .min(8, 'パスワードは8文字以上で入力してください'),
  password_confirmation: z
    .string()
    .min(1, 'パスワード確認は必須です'),
}).refine((data) => data.password === data.password_confirmation, {
  message: 'パスワードが一致しません',
  path: ['password_confirmation'],
});

/**
 * 店舗切り替えスキーマ
 */
export const changeStoreSchema = z.object({
  store_id: z
    .number()
    .positive('店舗を選択してください'),
});

// 型エクスポート
export type LoginFormValues = z.infer<typeof loginFormSchema>;
export type NFCLoginValues = z.infer<typeof nfcLoginSchema>;
export type ForgotPasswordValues = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>;
export type ChangeStoreValues = z.infer<typeof changeStoreSchema>;